import React from "react";
import PropTypes from "prop-types";

const UserProfileLayout = ({ children }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {children}
  </div>
);

UserProfileLayout.propTypes = {
  children: PropTypes.element,
};

export default UserProfileLayout;
